import React from "react";
import IconButton from "@mui/material/IconButton";
import PublicIcon from "@mui/icons-material/Public";
import "./TranslateMenu.css";

export default function TranslateMenu() {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Globe icon */}
      <IconButton
        aria-label="Change language"
        size="large"
        onClick={() => {
          const wrapper = document.querySelector(".gtranslate_wrapper");
          if (wrapper) wrapper.classList.toggle("visible");
        }}
      >
        <PublicIcon sx={{ color: "black", fontSize: 25 }} />
      </IconButton>

      {/* Always in DOM */}
      <div className="gtranslate_wrapper" />
    </div>
  );
}